var amdi18n={"__root":{"show_buttons":"Manage:","renew":"Renew","extend":"Extend","transfer":"Transfer","export":"Export","protect_with_pin":"Protect with PIN","remove_pin":"Remove PIN","activate":"Activate","deactivate":"Deactivate","delete":"Delete"},"__de":{"show_buttons":"Verwalten:","renew":"Erneuern","extend":"Erweitern","transfer":"Transferieren","export":"Exportieren","protect_with_pin":"mit PIN schützen","remove_pin":"PIN-Schutz aufheben","activate":"Aktivieren","deactivate":"Deaktivieren","delete":"Löschen"}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;


//////////////////
// WEBPACK FOOTER
// ./node_modules/amdi18n-loader!./src/main/web/js/app/view/identity/nls/IdentityButtonView_strings.js
// module id = 99
// module chunks = 1